import EmailTemplateList from './EmailTemplateList';

export default EmailTemplateList;
